import gql from 'graphql-tag';

export const getAvailableCompanyRoles = gql`
  query getAvailableCompanyRoles($propertyId: UUID!) {
    getAvailableCompanyRoles(propertyId: $propertyId) {
      id
      templateId
      name
      description
      moduleId
    }
  }
`;
